module.exports = __webpack_public_path__ + "wave-dot-matrix.3059938fd4bef240f2c1d74e29cfe7a7.svg";